<template>
  <div class="person-count-component">
    <span class="d-xl-none label">Кол-во персон</span>
    <span class="d-none d-xl-block label">Количество персон</span>
    <div class="counter d-flex align-center justify-center">
      <v-btn
        class="button-param font-weight-medium"
        depressed
        color="#F1F3F6"
        :disabled="disabled"
        @click="decrease"
      >
        <font-awesome-icon icon="minus" />
      </v-btn>
      <span class="count font-weight-medium">{{ count }}</span>
      <v-btn
        class="button-param font-weight-medium"
        depressed
        color="#F1F3F6"
        :disabled="disabled"
        @click="increase"
      >
        <font-awesome-icon icon="plus" />
      </v-btn>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'

  export default {
    name: 'PersonCount',
    mixins: [mixinSnackbarMessage],
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        count: 0,
        timeout: null,
      }
    },
    computed: {
      ...mapState({
        basket: (state) => state.baskets.basket,
      }),
    },
    watch: {
      'basket.persons' () {
        this.count = this.basket.persons || 0
      },
    },
    mounted () {
      this.count = this.basket.persons || 0
    },
    methods: {
      decrease () {
        if (this.count > 0) {
          this.count--
          this.updateBasket()
        }
      },
      increase () {
        this.count++
        this.updateBasket()
      },
      updateBasket () {
        const data = {
          persons: this.count,
        }
        const id = this.basket.id

        // Сразу в стор: иначе до ответа сервера «Перейти к оплате» видит 0 персон
        this.$store.commit('baskets/setBasketPersons', this.count)

        clearTimeout(this.timeout)

        this.timeout = setTimeout(() => {
          this.$store.commit('baskets/setBasketLoading', true)
          this.$store
            .dispatch('baskets/updateBasket', { data, id })
            .then((res) => {
              if (res.status === 200) {
                this.$store
                  .dispatch('baskets/fetchSingleBasket', id)
                  .then((res) => {
                    if (res.status === 200) {
                      this.count = this.basket.persons
                    }
                  })
              } else {
                this.showErrorMessage(res.response.data.message)
                // В сторе уже оптимистичное значение - возвращаем серверное
                this.$store.dispatch('baskets/fetchSingleBasket', id)
              }
            })
            .finally(() => {
              this.$store.commit('baskets/setBasketLoading', false)
            })
        }, 700)
      },
    },
  }
</script>

<style lang="less" scoped>
  .person-count-component {
    font-size: 12px;

    .media-xl({
      font-size: 14px;
    });

    .label {
      font-size: 1em;
      line-height: 1.5;
      display: block;
      margin-bottom: 6px;
    }

    .button-param {
      font-size: 1.78em;
      line-height: 1;
      width: 2em;
      height: 2em;
      min-width: 2em !important;
      padding: 0 !important;
    }

    .count {
      display: block;
      font-size: 1.78em;
      line-height: 1;
      margin: 0 12px;
    }
  }
</style>
